import React, { useContext } from "react";
import { Button } from "@/components/Button/Button";
import { Icon } from "@/components/Icon";
import IconsEnum from "enums/icons";
import { CalculatorContext } from "./CalculatorContext";
import s from "./styles/CalculatorCustomStyles.module.css";

const CalculatorCustomerTypeSelector = ({ properties, divider = false }) => {
  const setCalculatorCustomerType = (type) => {
    setCalculatorParams((prevParams) => ({
      ...prevParams,
      customerType: type,
    }));
  };

  const { setCalculatorParams, calculatorParams } =
    useContext(CalculatorContext);

  return (
    <div key={Math.random()}>
      <RadioToolbar
        properties={properties}
        divider={divider}
        setCalculatorCustomerType={setCalculatorCustomerType}
        calculatorCustomerType={calculatorParams.customerType}
      />
    </div>
  );
};

const RadioToolbar = ({
  properties,
  divider,

  setCalculatorCustomerType,
  calculatorCustomerType,
}) => {
  const handleClick = (type) => {
    setCalculatorCustomerType(type);
  };

  const buttonCommonClasses = `font-bold rounded-6 px-4 py-6 bg-gray-100 !border-none flex justify-center items-center w-full  text-blue-dark lg:px-[24px] !px-0`;
  const privateButtonClasses =
    calculatorCustomerType === "private"
      ? `${buttonCommonClasses} !bg-blue-light !text-white`
      : buttonCommonClasses;
  const businessButtonClasses =
    calculatorCustomerType === "business"
      ? `${buttonCommonClasses} !bg-blue-light !text-white`
      : `${buttonCommonClasses} `;

  return (
    <div className={`mb-8 mt-2`} key={Math.random()}>
      <div className={`${s.RadioToolbar}  flex-nowrap !flex-row  `}>
        <div className="w-full cursor-pointer" key={properties[1].label}>
          <button
            className={businessButtonClasses}
            onClick={() => handleClick("business")}
          >
            {properties[1].label}
          </button>
        </div>
        {divider && (
          <div className="flex justify-center items-center lg:p-7 p-2 select-none mx-4 lg:mx-0">
            <span className="">oder</span>
          </div>
        )}
        <div className="w-full cursor-pointer" key={properties[0].label}>
          <button
            className={privateButtonClasses}
            onClick={() => handleClick("private")}
          >
            {properties[0].label}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CalculatorCustomerTypeSelector;
